import React, { ReactElement, useContext } from 'react';
import { Immutable } from '@wds/utils';
import NotificationsIcon from './NotificationsIcon';
import NotificationsSheet from './NotificationsSheet';
import HeaderContext from '../../HeaderContext';
import useNotificationsCount from './useNotificationsCount';

export type NotificationsProps = Immutable<{
  showNotifications: boolean;
}> & {
  toggleNotifications(): void;
};

const Notifications = ({
  showNotifications,
  toggleNotifications,
}: NotificationsProps): ReactElement => {
  const { pageName, pageURL, user, lang } = useContext(HeaderContext);
  const userId = user?.userId;
  const packageId = user?.packageId;

  const [notificationsCount, fetchNotifications] =
    useNotificationsCount(showNotifications);

  return (
    <>
      <NotificationsIcon
        unreadNotificationsCount={notificationsCount}
        toggleNotifications={toggleNotifications}
        showNotifications={showNotifications}
        pageName={pageName}
        pageURL={pageURL}
      />
      <NotificationsSheet
        unreadNotificationsCount={notificationsCount}
        toggleNotifications={toggleNotifications}
        showNotifications={showNotifications}
        pageName={pageName}
        pageURL={pageURL}
        refetchNotificationIconCount={fetchNotifications}
        userId={userId}
        packageId={packageId}
        lang={lang}
      />
    </>
  );
};

export default Notifications;
export { Notifications };
